import pullAll from './pullAll'
export default function pull(data, ...values) {
  return pullAll(data, values)
}
